// External libraries
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import styled from 'styled-components';

// Zocdoc libraries
import { breakpoint } from '@zocdoc-frontend-common/styles-grid';

import { Dropdown } from '@zocdoc-frontend-common/components-dropdown';
import { Modal, ModalHeader } from '@zocdoc-frontend-common/components-modal';

class BaseBlueCrossBlueShieldModalView extends Component {
    static propTypes = {
        carriers: PropTypes.array,
        fetchBcbsCarriersIfNeeded: PropTypes.func.isRequired,
        isLoading: PropTypes.bool.isRequired,
        onChange: PropTypes.func.isRequired,
    };

    componentDidMount() {
        this.props.fetchBcbsCarriersIfNeeded();
    }

    render() {
        return (
            <Modal>
                <ModalHeader>
                    Which Blue Cross Blue Shield insurance do you have?
                </ModalHeader>

                <DropdownWrapper data-test="bcbs-modal">
                    {this.renderDropdown()}
                </DropdownWrapper>
            </Modal>
        );
    }

    renderDropdown() {
        const { carriers, isLoading } = this.props;

        if (isLoading) {
            return (
                <Dropdown
                    disabled
                    options={carriers}
                    placeholder="Loading..."
                />
            );
        }

        return (
            <Dropdown
                data-test="bcbs-carriers-dropdown"
                onChange={this.handleChange}
                options={carriers}
                placeholder="Choose Carrier"
            />
        );
    }

    handleChange = e => this.props.onChange(e.target.value);
}

const DropdownWrapper = styled.div`
    box-sizing: content-box;
    width: 100%;

    ${breakpoint.xsmall} {
        width: 75%;
    }
`;

export const BlueCrossBlueShieldModalView = BaseBlueCrossBlueShieldModalView;
